export default "__VITE_ASSET__51e3b3d2__"